import React, { useState, useEffect } from 'react';

export default function Contact() {
  const [loaded, setLoaded] = useState(false);
  const [formState, setFormState] = useState({
    name: '',
    email: '',
    company: '',
    subject: '',
    message: '',
  });
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  useEffect(() => {
    setLoaded(true);
  }, []);

  const handleChange = (e) => {
    setFormState({
      ...formState,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);

    const formData = new FormData();
    formData.append('form-name', 'contact');
    Object.entries(formState).forEach(([key, value]) => {
      formData.append(key, value);
    });

    try {
      await fetch('/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: new URLSearchParams(formData).toString(),
      });
      setSubmitted(true);
    } catch (error) {
      alert('There was an error submitting the form. Please try again.');
    }
    setSubmitting(false);
  };

  const inputStyles = {
    width: '100%',
    padding: '1rem 1.25rem',
    background: 'rgba(255, 255, 255, 0.03)',
    border: '1px solid rgba(74, 158, 255, 0.2)',
    borderRadius: '6px',
    color: '#ffffff',
    fontSize: '1rem',
    fontFamily: 'inherit',
    outline: 'none',
    transition: 'all 0.3s ease',
  };

  const labelStyles = {
    display: 'block',
    marginBottom: '0.5rem',
    color: '#a8c5e6',
    fontSize: '0.85rem',
    fontWeight: 500,
    letterSpacing: '0.05em',
    textTransform: 'uppercase',
  };

  const fieldGroupStyles = {
    marginBottom: '1.5rem',
  };

  if (submitted) {
    return (
      <div style={{
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '100px 5% 50px',
      }}>
        <div style={{
          textAlign: 'center',
          maxWidth: '500px',
        }}>
          <div style={{
            width: '80px',
            height: '80px',
            borderRadius: '50%',
            background: 'linear-gradient(135deg, rgba(74, 158, 255, 0.2) 0%, rgba(74, 158, 255, 0.05) 100%)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto 2rem',
            border: '1px solid rgba(74, 158, 255, 0.3)',
          }}>
            <svg width="40" height="40" viewBox="0 0 24 24" fill="none" stroke="#4a9eff" strokeWidth="2">
              <polyline points="20,6 9,17 4,12" />
            </svg>
          </div>
          <h2 style={{
            fontSize: '2rem',
            fontWeight: 600,
            color: '#ffffff',
            marginBottom: '1rem',
          }}>
            Message Received
          </h2>
          <p style={{
            color: '#a8c5e6',
            lineHeight: 1.7,
            fontSize: '1.05rem',
          }}>
            Thank you for reaching out to Parametrix Capital. We will review your inquiry and respond within 2 business days.
          </p>
        </div>
      </div>
    );
  }

  return (
    <div style={{
      minHeight: '100vh',
      padding: '120px 5% 80px',
    }}>
      <div style={{
        maxWidth: '1200px',
        margin: '0 auto',
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(400px, 1fr))',
        gap: '4rem',
        alignItems: 'start',
      }}>
        {/* Left Column - Info */}
        <div style={{
          opacity: loaded ? 1 : 0,
          transform: loaded ? 'translateY(0)' : 'translateY(20px)',
          transition: 'opacity 0.8s ease-out, transform 0.8s ease-out',
        }}>
          <h1 style={{
            fontSize: 'clamp(2rem, 5vw, 3.5rem)',
            fontWeight: 700,
            color: '#ffffff',
            marginBottom: '1.5rem',
            lineHeight: 1.1,
          }}>
            Contact Us
          </h1>
          
          <div style={{
            width: '80px',
            height: '2px',
            background: 'linear-gradient(90deg, #4a9eff 0%, rgba(74, 158, 255, 0) 100%)',
            marginBottom: '2rem',
          }} />

          {/* UPDATED MESSAGE */}
          <p style={{
            color: '#b8d4f1',
            fontSize: '1.1rem',
            lineHeight: 1.8,
            marginBottom: '3rem',
          }}>
            We welcome inquiries from individual investors, research partners, and industry professionals interested in our quantitative investment methodologies.
          </p>

          {/* Info Cards - ONLY RESPONSE TIME (Location removed) */}
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            gap: '1.5rem',
          }}>
            <div style={{
              padding: '1.5rem',
              background: 'rgba(255, 255, 255, 0.02)',
              border: '1px solid rgba(74, 158, 255, 0.1)',
              borderRadius: '8px',
            }}>
              <h3 style={{
                color: '#4a9eff',
                fontSize: '0.85rem',
                fontWeight: 600,
                letterSpacing: '0.1em',
                textTransform: 'uppercase',
                marginBottom: '0.75rem',
              }}>
                Response Time
              </h3>
              <p style={{
                color: '#a8c5e6',
                fontSize: '0.95rem',
                lineHeight: 1.6,
                margin: 0,
              }}>
                We typically respond to all inquiries within 2 business days.
              </p>
            </div>
          </div>
        </div>

        {/* Right Column - Form */}
        <div style={{
          opacity: loaded ? 1 : 0,
          transform: loaded ? 'translateY(0)' : 'translateY(20px)',
          transition: 'opacity 0.8s ease-out 0.2s, transform 0.8s ease-out 0.2s',
        }}>
          <div style={{
            background: 'rgba(255, 255, 255, 0.02)',
            border: '1px solid rgba(74, 158, 255, 0.15)',
            borderRadius: '12px',
            padding: '2.5rem',
          }}>
            {/* Hidden form for Netlify to detect */}
            <form name="contact" netlify="true" netlify-honeypot="bot-field" hidden>
              <input type="text" name="name" />
              <input type="email" name="email" />
              <input type="text" name="company" />
              <input type="text" name="subject" />
              <textarea name="message"></textarea>
            </form>

            <form onSubmit={handleSubmit}>
              <input type="hidden" name="form-name" value="contact" />
              
              {/* Honeypot field for spam protection */}
              <p hidden>
                <label>
                  Don't fill this out: <input name="bot-field" />
                </label>
              </p>

              {/* Name & Email Row */}
              <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))',
                gap: '1.5rem',
                marginBottom: '1.5rem',
              }}>
                <div>
                  <label style={labelStyles}>Full Name *</label>
                  <input
                    type="text"
                    name="name"
                    required
                    value={formState.name}
                    onChange={handleChange}
                    style={inputStyles}
                    onFocus={e => {
                      e.target.style.borderColor = '#4a9eff';
                      e.target.style.background = 'rgba(74, 158, 255, 0.05)';
                    }}
                    onBlur={e => {
                      e.target.style.borderColor = 'rgba(74, 158, 255, 0.2)';
                      e.target.style.background = 'rgba(255, 255, 255, 0.03)';
                    }}
                  />
                </div>
                <div>
                  <label style={labelStyles}>Email Address *</label>
                  <input
                    type="email"
                    name="email"
                    required
                    value={formState.email}
                    onChange={handleChange}
                    style={inputStyles}
                    onFocus={e => {
                      e.target.style.borderColor = '#4a9eff';
                      e.target.style.background = 'rgba(74, 158, 255, 0.05)';
                    }}
                    onBlur={e => {
                      e.target.style.borderColor = 'rgba(74, 158, 255, 0.2)';
                      e.target.style.background = 'rgba(255, 255, 255, 0.03)';
                    }}
                  />
                </div>
              </div>

              {/* Company */}
              <div style={fieldGroupStyles}>
                <label style={labelStyles}>Company / Institution</label>
                <input
                  type="text"
                  name="company"
                  value={formState.company}
                  onChange={handleChange}
                  style={inputStyles}
                  onFocus={e => {
                    e.target.style.borderColor = '#4a9eff';
                    e.target.style.background = 'rgba(74, 158, 255, 0.05)';
                  }}
                  onBlur={e => {
                    e.target.style.borderColor = 'rgba(74, 158, 255, 0.2)';
                    e.target.style.background = 'rgba(255, 255, 255, 0.03)';
                  }}
                />
              </div>

              {/* Subject */}
              <div style={fieldGroupStyles}>
                <label style={labelStyles}>Subject *</label>
                <input
                  type="text"
                  name="subject"
                  required
                  value={formState.subject}
                  onChange={handleChange}
                  placeholder="Topic of your inquiry"
                  style={{
                    ...inputStyles,
                    '::placeholder': { color: 'rgba(168, 197, 230, 0.4)' },
                  }}
                  onFocus={e => {
                    e.target.style.borderColor = '#4a9eff';
                    e.target.style.background = 'rgba(74, 158, 255, 0.05)';
                  }}
                  onBlur={e => {
                    e.target.style.borderColor = 'rgba(74, 158, 255, 0.2)';
                    e.target.style.background = 'rgba(255, 255, 255, 0.03)';
                  }}
                />
              </div>

              {/* Message */}
              <div style={fieldGroupStyles}>
                <label style={labelStyles}>Message *</label>
                <textarea
                  name="message"
                  required
                  rows={6}
                  value={formState.message}
                  onChange={handleChange}
                  placeholder="Please describe your inquiry in detail"
                  style={{
                    ...inputStyles,
                    resize: 'vertical',
                    minHeight: '150px',
                  }}
                  onFocus={e => {
                    e.target.style.borderColor = '#4a9eff';
                    e.target.style.background = 'rgba(74, 158, 255, 0.05)';
                  }}
                  onBlur={e => {
                    e.target.style.borderColor = 'rgba(74, 158, 255, 0.2)';
                    e.target.style.background = 'rgba(255, 255, 255, 0.03)';
                  }}
                />
              </div>

              {/* Submit Button */}
              <button
                type="submit"
                disabled={submitting}
                style={{
                  width: '100%',
                  padding: '1.1rem 2rem',
                  background: submitting 
                    ? 'rgba(74, 158, 255, 0.3)' 
                    : 'linear-gradient(135deg, #4a9eff 0%, #1a6ed8 100%)',
                  border: 'none',
                  borderRadius: '6px',
                  color: '#ffffff',
                  fontSize: '0.95rem',
                  fontWeight: 600,
                  letterSpacing: '0.05em',
                  textTransform: 'uppercase',
                  cursor: submitting ? 'not-allowed' : 'pointer',
                  transition: 'all 0.3s ease',
                  boxShadow: '0 4px 15px rgba(74, 158, 255, 0.2)',
                }}
                onMouseEnter={e => {
                  if (!submitting) {
                    e.target.style.transform = 'translateY(-2px)';
                    e.target.style.boxShadow = '0 6px 20px rgba(74, 158, 255, 0.3)';
                  }
                }}
                onMouseLeave={e => {
                  e.target.style.transform = 'translateY(0)';
                  e.target.style.boxShadow = '0 4px 15px rgba(74, 158, 255, 0.2)';
                }}
              >
                {submitting ? 'Sending...' : 'Submit Inquiry'}
              </button>

              <p style={{
                marginTop: '1.5rem',
                fontSize: '0.8rem',
                color: '#6b9bc9',
                textAlign: 'center',
                lineHeight: 1.6,
              }}>
                By submitting this form, you agree to be contacted regarding your inquiry.
              </p>
            </form>
          </div>
        </div>
      </div>

      {/* Placeholder styles for input placeholders */}
      <style>{`
        input::placeholder,
        textarea::placeholder {
          color: rgba(168, 197, 230, 0.4);
        }
        
        @media (max-width: 500px) {
          div[style*="gridTemplateColumns"] {
            grid-template-columns: 1fr !important;
          }
        }
      `}</style>
    </div>
  );
}
